export const SlippageToolTip =
  'Your transaction will revert if the price changes unfavourably by more than this percentage';
